<template>
  <div class="RwvContentSliderEdit">
    <p class="text-muted small">
      Der jeweilige Block kann zum ändern der Reihenfolge nach unten gezogen werden.
    </p>
    <draggable v-model="data.slides">
      <div v-for="(slide, slideIndex) in data.slides" :key="slideIndex">
        <b-row>
          <b-col>
            <b-button
              size="sm"
              block
              v-b-toggle="'input-group-slider-' + index + '-slide-' + slideIndex + 'collapse'"
              variant="primary">

              Slide {{slideIndex+1}}
            </b-button>
          </b-col>
          <b-col md="2" sm="3">
            <b-button
              size="sm"
              block
              variant="outline-danger"
              v-on:click="deleteSlide(slideIndex)">

              <i class="material-icons">delete</i>
            </b-button>
          </b-col>
        </b-row>

        <b-collapse :id="'input-group-slider-' + index + '-slide-' + slideIndex + 'collapse'"  class="mt-2">
          <b-form-group
            :id="'input-group-slider-' + index + '-slide-' + slideIndex + '-caption'"
            :label-for="'input-slider-' + index + '-slide-' + slideIndex + '-caption'"
            v-b-tooltip.hover
            title="Beschriftung">

            <b-form-input
              :id="'input-slider-' + index + '-slide-' + slideIndex + '-caption'"
              v-model="slide.caption"
              placeholder="Beschriftung">
            </b-form-input>
          </b-form-group>

          <b-form-group
            :id="'input-group-slider-' + index + '-slide-' + slideIndex + '-text'"
            :label-for="'input-slider-' + index + '-slide-' + slideIndex + '-text'"
            v-b-tooltip.hover
            title="Text">

            <b-form-input
              :id="'input-slider-' + index + '-slide-' + slideIndex + '-text'"
              v-model="slide.text"
              placeholder="Text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            :id="'input-group-slider-' + index + '-slide-' + slideIndex + '-image'">
            <RwvImageCropper @cropImage="cropImage" @deleteImage="deleteImage" :srcImage="slide.image" :index="slideIndex"></RwvImageCropper>
          </b-form-group>
        </b-collapse>
      </div>
    </draggable>

    <b-button
      variant="outline-primary"
      v-on:click="addSlide">
      Slide hinzufügen
    </b-button>
  </div>
</template>

<script>
import RwvImageCropper from "@/components/ImageCropper";
import draggable from 'vuedraggable'

export default {
  name: "RwvContentSliderEdit",
  components: {
    draggable,
    RwvImageCropper
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  methods: {
    cropImage(croppedImage, imageIndex) {
      this.data.slides[imageIndex].image = croppedImage
      this.$emit("changed", this.data)
    },
    deleteImage(index) {
      this.data.slides[imageIndex].image = ""
      this.$emit("changed", this.data)
    },
    addSlide() {
      console.log("addSlide")
      this.data.slides.push({
          image: "",
          caption: "",
          text: ""
        })
    },
    deleteSlide(slideIndex) {
      this.data.slides.splice(slideIndex, 1);
      this.$emit("changed", this.data)
    }
  }
};
</script>
